import * as React from 'react'
import { useDispatch } from 'redux-react-hook'
import { setPage } from '../../../actions/header.action'
import { getPatientDetails } from '../../../actions/patient.action'
import { Header } from '../../molecules/header/index'
import styled from 'styled-components'
import { Size } from '../../../constants/app.constant'
import Contents from './contents'
import * as HeaderConst from '../../../constants/header.constant'
import useGetState from '../../../hooks/use-get-state'

const { useEffect } = React

const PasswordChangeForm: React.SFC = () => {
  const dispatch = useDispatch()
  const {
    state: { auth },
  } = useGetState()
  useEffect(
    () => {
      document.title = 'パスワード変更'
      dispatch(setPage(HeaderConst.HEADER_REPORT))
      dispatch(
        getPatientDetails({
          patientId: auth.user.idToken.payload['custom:userId'],
          jwtToken: auth.user.idToken.jwtToken,
        })
      )
    },
    [auth.user.idToken.jwtToken, auth.user.idToken.payload, dispatch]
  )
  return (
    <Wrapper>
      <Header />
      <Contents />
    </Wrapper>
  )
}
export default PasswordChangeForm
const Wrapper = styled.div`
  max-width: ${Size.BREAK_POINT.MOBILE}px;
  background: white;
  margin: 0 auto;
`



// WEBPACK FOOTER //
// ./src/components/pages/password_change/passwordchange_form.tsx